import React, { useState } from 'react';
import NavPage from '../ComponentsPage/NavPage';
import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import NotificationTabs from './NotificationTabs';
import ConfigurationTabs from './ConfigurationTabs';
import { useSelector } from 'react-redux';
import ErrorPage from 'pages/z-error/404';
import { NOTIFICATION_TAB } from 'lib/config';

const ManageNotifications = () => {
  const [value, setValue] = useState('notifications');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const accessUser = useSelector((state) => state.merchantRoleAccess.data);
  const haveAccessNotifcations = (access, flag) => {
    if (!access) return false;
    return flag !== 'disabled';
  };

  if (!haveAccessNotifcations(accessUser?.data?.access, NOTIFICATION_TAB)) return <ErrorPage />;
  return (
    <Box className="bg-white rounded-md shadow-md">
      <NavPage />
      <div className="px-8 py-6">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Email Notifications</h2>
          <p>Manage which email notifications you want to receive for your merchant account</p>
          <Box className="mt-5" sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
              <Box className="w-full md:w-fit bg-grey-100 p-1 rounded-lg">
                <TabList
                  onChange={handleChange}
                  TabIndicatorProps={{ style: { display: 'none', backgroundColor: 'tomato' } }}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    '& .MuiTab-root': {
                      flex: 2,
                      textTransform: 'none',
                      fontWeight: 500,
                      color: '#6b7280',
                      justifyContent: 'center',
                    },
                    '& .Mui-selected': {
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      color: '#111827',
                    },
                  }}>
                  <Tab label="Notifications" value="notifications" />
                  <Tab label="Configuration" value="configuration" />
                </TabList>
              </Box>
              <TabPanel value="notifications" sx={{ padding: 0, marginTop: '12px' }}>
                <NotificationTabs />
              </TabPanel>
              <TabPanel value="configuration" sx={{ padding: 0, marginTop: '12px' }}>
                <ConfigurationTabs />
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </div>
    </Box>
  );
};

export default ManageNotifications;
